// Terjemahan Bahasa Melayu
export const ms = {
  title: 'HandinCap',
  subtitle: 'Kad Skor Anda',
  create: 'Permainan Baru',
  courseTitle: 'Tetapan Padang',
  autoMode: 'Cari Auto',
  manualMode: 'Input Manual',
  searchPlaceholder: 'Cari nama padang...',
  selectCourse: 'Pilih Padang',
  gameType: 'Jenis Permainan',
  setPar: 'Tetapkan Nilai PAR',
  confirmCourse: 'Sahkan',
  playerTitle: 'Tetapan Pemain',
  players: 'Pemain',
  player1: 'Pemain 1',
  player2: 'Pemain 2',
  player3: 'Pemain 3',
  player4: 'Pemain 4',
  player5: 'Pemain 5',
  player6: 'Pemain 6',
  player7: 'Pemain 7',
  player8: 'Pemain 8',
  enterName: 'Masukkan nama',
  gameMode: 'Mod Permainan',
  matchPlay: 'Match Play',
  win123: 'Win123',
  skins: 'Skins',
  baccarat: 'Baccarat',
  stake: 'Taruhan',
  prizePool: 'Tabung Hadiah',
  penaltyPot: 'Tabung Penalti',
  optional: 'Pilihan',
  enterStake: 'Masukkan jumlah (pilihan)',
  handicap: 'Handicap',
  handicapSettings: 'Tetapan Handicap',
  off: 'Mati',
  on: 'Hidup',
  back: 'Kembali',
  start: 'Mula Permainan',
  hole: 'Lubang',
  par: 'PAR',
  nextHole: 'Sahkan & Seterusnya',
  currentMoney: 'Kedudukan Semasa',
  poolBalance: 'Baki Tabung',
  holeTied: 'Lubang Seri',
  poolGrows: 'Tabung lubang seterusnya',
  skinsWinner: '{player} menang Skin!',
  holeSettlement: 'Penyelesaian Lubang',
  netScore: 'Bersih',
  rank: 'Ke-{n}',
  winner: 'Pemenang',
  resume: 'Sambung Permainan',
  finishRound: 'Sahkan & Tamat',
  kaki: 'Kaki Golf',
  kakiDeleteConfirm: 'Padam Kaki Golf ini?',
  confirmHoleScore: 'Sahkan Skor Lubang {hole}',
  holeScoresSummary: 'Skor Pemain:',
  cancel: 'Batal',
  yes: 'Ya',
  confirm: 'Sahkan',
  switchLang: 'Bahasa',
  noStake: 'Sila masukkan jumlah taruhan',
  atLeast2: 'Sila masukkan sekurang-kurangnya 2 pemain',
  gameOver: 'Permainan Tamat!',
  backToHome: 'Kembali ke Utama',
  out: 'Keluar',
  in: 'Masuk',
  total: 'Jum',
  totalScore: 'Jumlah Skor',
  standardPar: 'Par',
  finalSettlement: 'Penyelesaian Akhir',
  noScoreData: 'Belum ada skor direkodkan',
  f9: 'Depan 9',
  b9: 'Belakang 9',
  f18: 'Depan 18',
  b18: 'Belakang 18',
  f9Desc: 'Lubang 1-9',
  b9Desc: 'Lubang 10-18',
  f18Desc: 'Standard 1-18',
  b18Desc: '10-18, 1-9',
  duplicateNames: 'Nama pemain mesti unik',
  screenshotHint: 'Disyorkan tangkap skrin untuk simpan rekod',
  totalLoss: 'Jumlah',
  totalPar: 'PAR',
  noCourses: 'Tiada padang dijumpai',
  trySearch: 'Cuba kata kunci lain',
  front9: 'Depan 9',
  back9: 'Belakang 9',
  eagle: 'Eagle',
  birdie: 'Birdie',
  parLabel: 'Par',
  bogey: 'Bogey',
  doubleplus: 'Double+',
  selectHoleToEdit: 'Pilih Lubang untuk Edit',
  holeJumpTitle: 'Lompat ke Lubang',
  holeJumpReturnToast: 'Tinggal {n} lubang — kembali ke lubang {hole}',
  editHole: 'Edit',
  save: 'Simpan',
  scoreUpdated: 'Skor dikemas kini, wang dikira semula',
  matchPlayDesc: 'Bersih terendah menang, yang kalah bayar taruhan',
  win123Desc: 'Penalti ikut kedudukan, UP untuk risiko/ganjaran',
  skinsDesc: 'Semua masuk setiap lubang, terendah sahaja ambil',
  baccaratDesc: 'Lawan satu-satu, UP gandakan taruhan',
  reportTitle: ' Laporan',
  scoreDistribution: 'Taburan Skor',
  puttingAnalysis: 'Analisis Putt',
  totalPutts: 'Jumlah Putt',
  avgPerHole: 'Purata/Lubang',
  onePutt: 'Satu-Putt',
  threePutts: '3-Putt+',
  holes: ' lubang',
  penaltyStats: 'Statistik Penalti',
  waterHazard: 'Air',
  stats: ' Statistik',
  attempts: ' Percubaan',
  times: '',
  holeByHole: 'Lubang demi Lubang',
  viewFullDetail: 'Lihat Penuh',
  fullDetail: 'Butiran Penuh',
  strokes: ' pukulan',
  putt: 'Putt',
  water: 'Air',
  clickNameToView: 'Ketik nama untuk lihat butiran',
  confirmPutts: 'Sahkan Putt',
  zeroPuttsWarning: 'Pemain berikut mempunyai 0 putt:',
  puttsScore: 'Skor',
  puttsStrokes: '',
  puttsPutts: 'Putt',
  puttsTip: 'Tip: Melainkan chip-in, putt biasanya bukan 0',
  puttsGoBack: 'Kembali',
  puttsConfirm: 'Sahkan',
  mpMultiplayer: 'Multiplayer',
  mpSync: 'Multiplayer Sync',
  mpCodePlaceholder: 'KOD',
  mpEnter6Digit: 'Masukkan kod 4 digit',
  mpJoin: 'Sertai',
  mpPointQr: 'Halakan ke kod QR',
  mpQrLoadFail: 'QR gagal dimuat',
  mpLinkCopied: 'Pautan disalin!',
  mpCopyLink: 'Salin Pautan',
  mpShareLink: 'Kongsi',
  startSolo: 'Mula Solo',
  mpJumbo: 'Jumbo',
  mpCreateRoom: 'Cipta Bilik',
  mpWaitingPartner: 'Menunggu Rakan',
  mpWaitingStart: 'Menunggu Mula',
  mpRoomCode: 'Kod Bilik',
  mpCopied: 'Disalin!',
  mpCopyCode: 'Salin Kod',
  mpScanToJoin: 'Imbas untuk sertai',
  mpGameInfo: 'Info Permainan',
  mpCourse: 'Padang',
  mpMode: 'Mod',
  mpStake: 'Taruhan',
  mpRoom: 'Bilik',
  mpPlayerAssignment: 'Tugasan Pemain',
  mpMine: 'Saya',
  mpPartner: 'Rakan',
  mpUnclaimed: 'Belum dituntut',
  mpConnected: 'Bersambung',
  mpError: 'Ralat',
  mpConnecting: 'Menyambung...',
  mpStartGame: 'Mula Permainan',
  mpWaitingCreator: 'Menunggu pencipta memulakan permainan...',
  mpClaimTitle: 'Tuntut Pemain Anda',
  mpClaimDesc: 'Pilih pemain yang anda akan skor',
  mpSelectOne: 'Pilih sekurang-kurangnya satu pemain',
  mpConfirmClaim: 'Sahkan Tuntutan',
  mpConfirmSubmit: 'Sahkan',
  mpWaiting: 'Menunggu...',
  mpConfirmFinish: 'Sahkan & Tamat',
  mpConfirmNext: 'Sahkan & Seterusnya',
  mpAdvancedStats: 'Mod Statistik Lanjutan',
  mpHolesLabel: 'Lubang',
  hcpLabel: 'HCP',
  hideInfo: 'Sembunyikan',
  learnMore: 'Ketahui lebih',
  close: 'Tutup',
  clearRecent: 'Padam',
  recentCourses: 'Padang Terkini',
  endGame: 'Tamat',
  shareRoundReport: 'Kongsi Laporan Pusingan',
  allDataCleared: 'Semua data permainan akan dipadam',
  endGameConfirm: 'Tamatkan permainan sekarang?\nLubang tidak siap tidak akan dikira',
  holeLabel: 'Lubang {n}',
  holeLabelShort: 'L{n}',
  cameraAccessDenied: 'Akses kamera ditolak',
  generateLinkFailed: 'Gagal menjana pautan',
  copyFailed: 'Gagal menyalin',
  retracted: 'Ditarik balik. Anda boleh ubah skor.',
  matchPlayBubble: 'Bersih terendah menang setiap lubang. Seri? Tiada bayaran.',
  win123Bubble: 'Kedudukan ikut skor bersih. Kedudukan rendah = penalti besar. UP untuk risiko/ganjaran.',
  skinsBubble: 'Terendah sahaja ambil tabung. Seri? Bawa ke lubang seterusnya.',
  baccaratBubble: '4 pemain, 6 perlawanan. Panggil UP untuk naikkan taruhan.',
  mpSyncBubble: 'Anda skor pemain anda, rakan skor mereka. Skor disegerakkan automatik.',
  hcpBubble: 'Handicap (0-36): Menyeimbangkan pemain berlainan tahap. Pukulan diagihkan auto mengikut kesukaran lubang.',
  undoEdit: 'Buat Asal & Edit',
  waitingProceed: 'Menunggu {badge} meneruskan...',
  voiceWithHcp: '{player}, {on} on, {putt} {puttWord}, {handicap} handicap.',
  voiceNoHcp: '{player}, {on} on, {putt} {puttWord}.',
  voiceHoleIntro: 'Ini Lubang {hole}, Par {par}, Indeks {index}.',
  voiceHoleIntroNoIdx: 'Ini Lubang {hole}, Par {par}.',
  voiceHcpOnHole: '{player}, {strokes} pukulan handicap',
  ttsLang: 'ms-MY',
  editLogTitle: 'Log Perubahan',
  editLogHoleTitle: 'Lubang {n} Log Perubahan',
  editLogEmpty: 'Tiada perubahan direkodkan',
  editLogCount: '{n} perubahan',
  editLogAllRecorded: 'Semua perubahan telah direkodkan',
  editLogScore: 'Skor',
  editLogPutts: 'Putt',
  editLogUp: 'UP',
  editNotifyTitle: 'Skor lubang {n} diubah',
  editNotifyBy: 'Diubah oleh {who}',
  editNotifyDetail: 'Ketik untuk butiran',
  editLogTapHint: 'Ketik pada nombor lubang untuk lihat log',
  editLogClose: 'Tutup',
  // Viewer Mode
  mpRoleTitle: 'Sertai Bilik',
  mpRoleDesc: 'Bagaimana anda ingin menyertai?',
  mpPlayerRole: 'Pemain',
  mpPlayerRoleDesc: 'Tuntut pemain dan masukkan skor',
  mpPlayerTagInput: 'Masukkan skor',
  mpPlayerTagClaim: 'Tuntut pemain',
  mpViewerRole: 'Penonton',
  mpViewerRoleDesc: 'Tonton permainan secara langsung',
  mpViewerTagLive: 'Skor langsung',
  mpViewerTagNoInput: 'Tiada input',
  mpViewerBanner: 'TONTONAN SAHAJA — input skor dilumpuhkan',
  mpViewerReminder: 'Anda sedang menonton permainan ini',
  mpViewerReminderDesc: 'Skor dikemas kini secara langsung. Anda tidak boleh memasukkan atau mengubah skor.',
  exit: 'Keluar',
  // Scorecard Section
  scorecardHorizontal: 'Mendatar',
  scorecardVertical: 'Menegak',
  shareBtn: 'Kongsi',
  penalties: 'Penalti',
  // Feedback Maklum Balas
  feedbackBtn: 'Maklum Balas',
  feedbackTitle: 'Maklum Balas',
  feedbackSubtitle: 'Bantu kami perbaiki HandinCap',
  feedbackRateLabel: 'Nilaikan pengalaman anda',
  feedbackCatLabel: 'Apa yang perlu diperbaiki? (boleh pilih banyak)',
  feedbackCatNewModes: 'Mod permainan baru',
  feedbackCatUI: 'Antara muka',
  feedbackCatSpeed: 'Prestasi',
  feedbackCatCourse: 'Data padang',
  feedbackCatScoring: 'Pemarkahan',
  feedbackCatMultiplayer: 'Multiplayer',
  feedbackCatBug: 'Laporan bug',
  feedbackCatOther: 'Lain-lain',
  feedbackCommentPlaceholder: 'Beritahu kami pendapat anda...\nContoh: Mahu mod Nassau',
  feedbackSubmit: 'Hantar Maklum Balas',
  feedbackSubmitting: 'Menghantar...',
  feedbackThanks: 'Terima kasih!',
  feedbackThanksDetail: 'Kami membaca setiap maklum balas',
  feedbackSkip: 'Nanti',
  feedbackStar1: 'Teruk',
  feedbackStar2: 'Biasa',
  feedbackStar3: 'OK',
  feedbackStar4: 'Bagus',
  feedbackStar5: 'Hebat!',
  // Share page
  shareInvalidLink: 'Pautan Tidak Sah',
  shareInvalidDesc: 'Pautan kongsi ini tidak sah atau telah tamat tempoh.',
  shareGoTo: 'Pergi ke HandinCap',
  poweredBy: 'Dikuasakan oleh',
  onLabel: 'On',
  avg: 'Purata',
  totalLabel: 'Jumlah',
  // Multiplayer extras
  mpConnectionStatus: 'Status Sambungan',
  mpPlayersJoined: 'Pemain menyertai',
  mpViewersJoined: 'Penonton menyertai',
  mpNoPlayersYet: 'Tiada pemain menyertai lagi. Anda masih boleh mula — anda akan skor semua pemain sendiri.',
  mpProcessing: 'Memproses...',
  mpClaimed: 'Dituntut',
  mpNoPlayers: 'Tiada pemain tersedia',
  ob: 'OB',
  allConfirmed: 'Semua Disahkan',
  liveSyncing: 'Segerak langsung',
  justNow: 'baru sahaja',
  minsAgo: '{n}m lalu',
  hrsAgo: '{n}j lalu',
  roomNotFound: 'Bilik tidak dijumpai',
  // Round Report
  rrTitle: 'LAPORAN PUSINGAN',
  rrGolfCourse: 'Padang Golf',
  rrTotalScorePar: 'Jumlah Skor (Par: {n})',
  rrShareImage: 'Kongsi Gambar',
  rrShareLink: 'Kongsi Pautan',
  rrImageDownloaded: 'Gambar dimuat turun',
  rrImageFailed: 'Gagal menjana gambar',
  rrScreenshotFailed: 'Tangkap skrin gagal, sila tangkap secara manual',
  rrOpenApp: 'Buka HandinCap',
  loading: 'Memuatkan...',
};

export default ms;
